import React,{ useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import { errorToast, successToast } from "./common/showtoast";
import Swal from "sweetalert2";

export default function Upgrade() {
  const [epins, setEpins] = useState([]);
  const [upgraded, setupgraded] = useState(false);
  const [currentPackage, setCurrentPackage] = useState("0");
  let history = useHistory();
  useEffect(() => {
    GetEpins();
  }, []);
  const GetEpins = async () => {
    let res1 = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    if (res1.status === "error") {
      if (res1.message === "Token Expired") {
        localStorage.clear();
        errorToast(res1.message);
        history.push("/");
      }
      return;
    }
    setCurrentPackage(res1.activepackage);
    if (res1.activepackage === "1" || parseFloat(res1.activepackage) >= 1000) {
      setupgraded(true);
    }
    let res = await ApiRequest("unusedpins.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        errorToast(res.message);
        history.push("/");
      }
      setEpins([]);
      return;
    }
    let items = res.items;
    if (res1.activepackage)
      items = res.items.filter((e) => parseFloat(e.pinvalue) > (res1.activepackage == "1" ? 1000 : parseFloat(res1.activepackage)));
    setEpins(items);
  }
  const onTransferConfirm = async (json) => {
    let res = await ApiRequest("buycontract.asp", "POST", json, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        history.push("/login");
      }
      return { success: false, message: res.message };
    }
    successToast(res.message);
    return { success: true, message: "" }
  }
  return (
    <div>
      <PageHeader title="Upgrade" />
      <div className="row">
        <div className="col-lg-12 col-md-12 row ml-1 d-flex">
          <div className="card">
            <div className="card-header">
              <h3
                className="card-title text-color-3"
                style={{ fontWeight: 200, fontSize: 22 }}
              >
                                Upgrade
              </h3>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                  style={{ textAlign: "center" }}
                >
                  <thead className="">
                    <tr>
                      <th>S.No</th>
                      <th>Pin ID</th>
                      <th>Pin Pass</th>
                      <th>Product Code</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody >
                    {
                      epins.length <= 0 ? <tr>
                        <td colSpan={"7"}>{upgraded ? "You are already upgraded all the packages" : "No pins found to upgrade. Please purchase pins higher than your current package : " + currentPackage}</td>
                      </tr> : epins.map((e, i) => {
                        return <tr key={i}>
                          <td className="tabletd">{(i + 1)}</td>
                          <td>{e.pinid}</td>
                          <td>{e.pinpass}</td>
                          <td>{e.productcode}</td>
                          <td>{e.pinvalue ? e.pinvalue : "-"}</td>
                          <td>{e.solddate}</td>
                          <td>
                            <button className="badge badge-primary" onClick={async () => {
                              await Swal.fire({
                                title: "Your transaction password",
                                input: "password",
                                inputLabel: "Your transaction password",
                                inputPlaceholder: "Enter your transaction password",
                                showCancelButton: true,
                                inputValidator: async (value) => {
                                  if (!value) {
                                    return "Please enter your transaction password or cancel!"
                                  }
                                  let t = {
                                    pinid: e.pinid,
                                    memberid: localStorage.getItem("username"),
                                    pinpass: e.pinpass,
                                    tac: value
                                  };
                                  console.log(t);
                                  let sta = await onTransferConfirm(t);
                                  if (!sta.success) {
                                    return sta.message
                                  }
                                  GetEpins();
                                }
                              })
                            }}>Upgrade</button>
                          </td>
                        </tr>
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}